<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('收货人')" prop="realName">
                <a-input v-model="queryParam.realName" :maxLength="32" :placeholder="$t('请输入')+$t('收货人')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile" :maxLength="32" :placeholder="$t('请输入')+$t('手机号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('省份')" prop="areapId">
                <a-select :placeholder="$t('请选择')+$t('省份')" style="width: 100%" v-model="queryParam.areapId" allowClear>
                  <a-select-option v-for="(item, index) in this.areaList" :value="item.areaId+''"
                                   :key="index">
                    {{ item.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md=" 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['merchant:merchantaddress:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:merchantaddress:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:merchantaddress:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['merchant:merchantaddress:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :area-list="areaList" @ok="getList"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isDefault" slot-scope="text, record">
          <custom-dict-tag :options="customDict.TFEnum" :value="record.isDefault"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['merchant:merchantaddress:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:merchantaddress:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantaddress:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['merchant:merchantaddress:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMerchantAddress,listMerchantAddress, delMerchantAddress } from '@/api/merchant/merchantAddress'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {areaListTree} from "@/api/logistics";

export default {
  name: 'MerchantAddress',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      areaList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        realName: undefined,
        mobile: undefined,
        longitude: undefined,
        latitude: undefined,
        areapId: undefined,
        areap: undefined,
        areacId: undefined,
        areac: undefined,
        areaxId: undefined,
        areax: undefined,
        detailedAddress: undefined,
        merchantId: undefined,
        isDefault: undefined,
        deptId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('收货人'),
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('区域'),
          dataIndex: 'areaName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('详细地址'),
          dataIndex: 'detailedAddress',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商家'),
          dataIndex: 'merchantName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否默认'),
          dataIndex: 'isDefault',
          scopedSlots: { customRender: 'isDefault' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getAreaTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商家地址列表 */
    getList () {
      this.loading = true
     pageMerchantAddress(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        realName: undefined,
        mobile: undefined,
        longitude: undefined,
        latitude: undefined,
        areapId: undefined,
        areap: undefined,
        areacId: undefined,
        areac: undefined,
        areaxId: undefined,
        areax: undefined,
        detailedAddress: undefined,
        merchantId: undefined,
        isDefault: undefined,
        deptId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let delData  = {"idList": this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delMerchantAddress(delData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/merchant/address/export',
            that.queryParam
          , `商家地址_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
